import { Text, BetaRadioGroup, BetaRadio } from '@bevy/bevy-design-system';
import styles from './styles.module.less';
import PropTypes from 'prop-types';
import { useController, useFormContext } from 'react-hook-form';

const StyledRadioInput = ({ option }) => {
  return (
    <div className={styles.radioInputGroup}>
      <BetaRadio size='small' value={option.value} />
      <Text variant='label' size='small' htmlFor={option.value}>
        {option.label}
      </Text>
    </div>
  );
};

StyledRadioInput.propTypes = {
  option: PropTypes.object,
};

/**
 * React Hook From Controlled Radio Input
 * @param {string} name
 * @param {string} label
 * @param {string} ariaLabel
 * @param {object} options
 * @param {object} rules
 * @see {Documentation} https://react-hook-form.com/docs/usecontroller
 * @returns {React.Component}
 */

const ControlledRadioInput = ({ name, label, ariaLabel, options, rules }) => {
  const { control } = useFormContext();
  const {
    field: radioInput,
    fieldState: { error },
  } = useController({ name, control, rules });
  return (
    <div className={styles.radioInput}>
      <Text variant='label' size='medium'>
        {label}
      </Text>
      <BetaRadioGroup
        name={name}
        size='small'
        ariaLabel={ariaLabel || label}
        value={radioInput.value}
        onChange={radioInput.onChange}
        errors={error ? [error?.message] : null}
        rules={rules}
      >
        {options.map((option, idx) => (
          <StyledRadioInput key={idx} option={option} />
        ))}
      </BetaRadioGroup>
      {error?.message && (
        <Text variant='helper' color='error' size='small'>
          {error.message}
        </Text>
      )}
    </div>
  );
};

ControlledRadioInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.node.isRequired,
    }),
  ),
  rules: PropTypes.object,
};

export default ControlledRadioInput;
